import styled from 'styled-components'
import {ButtonLink} from '@modifi/ui'
import {lightGray} from '@modifi/colors'

import {Td} from '../../../../ui'

export const StyledButtonLink = styled(ButtonLink)`
  &:hover,
  &:focus {
    background: ${lightGray};
  }
`

export const RightAlignedTd = styled(Td)`
  text-align: right;
`

export const StyledComment = styled.div`
  margin-top: 5px;
  width: 250px;
  word-break: break-word;
`
